// Datasets are Dash0's hard partitions, and only production traffic belongs in
// the production one. Shared by the server (VERCEL_ENV) and client
// (NEXT_PUBLIC_VERCEL_ENV) configs, which read different env vars because they
// run in different runtimes.
export function resolveDash0Dataset(vercelEnv: string): 'production' | 'development' {
  return vercelEnv === 'production' ? 'production' : 'development';
}
